export default {
  projectid: "0123456789",
  projectname: "projectname",
  datestring: "2021/11/02", 
  planid: "",
  createdate: "",
}